import { get } from 'lodash';

import { LDProps } from '../core/providers/launch-darkly';
import { isProdEnvironment } from './env-utils';

/**
 * Checks if the platform has the analytics enabled.
 *
 * NOTE: The default value for PROD environment is true as we want to have
 * the analytics always enabled (in case of LaunchDarkly being down).
 * @param {LDProps['flags']} flags
 */
export function hasPlatformEnableAnalyticsEnabled(flags: LDProps['flags']): boolean {
  const defaultValue = isProdEnvironment();
  return get(flags, 'platformEnableAnalytics', defaultValue);
}
